export default __webpack_public_path__ + "static/media/disconnect_blue.bc1a49d3.svg";